import { useEffect, useState } from "react";
import ToursCard from "./ToursCard";
import Toursicon from "../../../assets/images/Tours-icon.svg";
import ResponsiveToursCard from "./ResponsiveToursCard";
import Arrow from "../../../assets/images/Arrow.svg";
import Check from "../../../assets/images/fi_check.svg";
import { useSelectedTours } from "../../../contexts/SelectedToursContext";
import { createPortal } from "react-dom";
import Companies from "../../../components/Companies";
import Modal2 from "../../../components/Modal2";
import { FaQuestionCircle } from "react-icons/fa";
import toast from "react-hot-toast";
import CenteredToast from "../../../components/CenteredToast";

function ResponsiveTours({
  tourData,
  bookings,
  selectedTours,
  setSelectedTours,
}) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isClosable, setIsClosable] = useState(false);
  const [expandedGroupIndex, setExpandedGroupIndex] = useState(0); // Track the expanded group
  const [tourDataState, setTourDataState] = useState(tourData);

  const handleGroupClick = (index) => {
    setExpandedGroupIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleTourClick = (Id) => {
    const { title, time, category } = Id;
    if (Id.booked) return;

    setTourDataState((prevTourDataState) => {
      return prevTourDataState?.map((group) => {
        if (group.group === category) {
          return {
            ...group,
            tours: group.tours?.map((tour) =>
              tour?.tour === title && tour.time === time
                ? { ...tour, selected: !tour.selected }
                : tour
            ),
          };
        }
        return group;
      });
    });
    const bookedServicesStartTime = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.startTime)
    );
    const bookedServicesEndTime = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.endTime)
    );

    const bookedServiceIds = tourData?.flatMap((group) =>
      group.tours
        .filter((tour) => tour?.booked === 1)
        .map((tour) => tour?.tourId)
    );
    const parseTime = (timeStr) => new Date(`1970-01-01T${timeStr}Z`);
    const newStart = parseTime(Id.startTime);
    const newEnd = parseTime(Id.endTime);

    // ✅ Prevent selecting tours that overlap in time (even by 1 minute)
    const isTimeOverlapping = bookedServicesStartTime?.some(
      (startTime, index) => {
        const bookedStart = parseTime(startTime);
        const bookedEnd = parseTime(bookedServicesEndTime[index]);

        return newStart < bookedEnd && newEnd > bookedStart;
      }
    );

    if (bookedServiceIds.includes(Id.tourId)) {
      setToastMessage(
        "You cannot book more than one appointment in the same category. Please cancel your current booking first, then proceed with the new one.!"
      );
      setShowToast(true);
      setIsClosable(true);
      return;
    }
    if (isTimeOverlapping) {
      setToastMessage("Time overlaps with an existing booking!");
      setShowToast(true);
      setIsClosable(false);
      return;
    }
    // if (isTimeOverlapping) {
    //   toast.error("Time overlaps with an existing booking");
    // }

    // if (bookedServiceIds.includes(Id.tourId)) {
    //   toast.error("This tour is already booked");
    // }

    setSelectedTours((prevSelectedTours) => {
      // ✅ Prevent selecting booked tours
      if (bookedServiceIds.includes(Id.tourId)) {
        return prevSelectedTours; // Return without changes
      }
      if (isTimeOverlapping) {
        return prevSelectedTours; // Return without changes
      }

      const tourIndex = prevSelectedTours?.findIndex(
        (selectedTour) => selectedTour.tourId === Id.tourId
      );

      if (tourIndex >= 0) {
        // If the tour is already selected, remove it s
        return prevSelectedTours?.filter(
          (selectedTour) => selectedTour.tourId !== Id.tourId
        );
      } else {
        // ✅ Remove overlapping tours from prevSelectedTours
        const nonOverlappingTours = prevSelectedTours?.filter(
          (existingTour) => {
            const existingStart = parseTime(existingTour.startTime);
            const existingEnd = parseTime(existingTour.endTime);

            return !(newStart < existingEnd && newEnd > existingStart); // Keep only non-overlapping tours
          }
        );

        // ✅ Add the new tour to the selection
        return [...nonOverlappingTours, Id];
      }
    });
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute] = time24.split(":");
    const hours = parseInt(hour, 10);
    const suffix = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
    return `${hours12}:${minute} ${suffix}`;
  };

  const [isCodeModalOpen, setIsCodeModalOpen] = useState(false);
  const openCodeModal = () => setIsCodeModalOpen(true);
  const closeCodeModal = () => setIsCodeModalOpen(false);
  const [getTourId, setGetTourId] = useState();
  return (
    <>
      {" "}
      {showToast && (
        <CenteredToast
          message={toastMessage}
          onClose={() => setShowToast(false)}
          isClosable={isClosable}
        />
      )}
      {createPortal(
        <Modal2 isOpen={isCodeModalOpen} closeModal={closeCodeModal}>
          <Companies
            closeCodeModal={closeCodeModal}
            getTourId={getTourId}
            openCodeModal={openCodeModal}
          />
        </Modal2>,
        document.body
      )}
      <div className="leap-flex leap-flex-row leap-gap-8 leap-justify-center leap-p-4 ">
        <div className="leap-flex leap-flex-col leap-gap-4 leap-w-full leap-items-end">
          {tourData?.map((group, index) => (
            <ResponsiveToursCard
              key={index}
              icon={Toursicon}
              title={group.group}
              gradientBackground="linear-gradient(180deg, #8547F6 0%, #BC98FF 100%)"
              conicBackground="linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),conic-gradient(from 181.06deg at 50% 50%, rgba(71, 47, 140, 0.4) 0deg, rgba(0, 0, 0, 0) 172.66deg, #4a358268 281.25deg, rgba(71, 47, 140, 0.4) 360deg)"
              isExpanded={expandedGroupIndex === index}
              handleGroupClick={() => handleGroupClick(index)}
            />
          ))}
        </div>

        {/* Tours of the Expanded Group (Right Column) */}
        <div className="leap-flex leap-flex-col leap-gap-11 leap-w-full leap-items-start">
          {expandedGroupIndex !== null && (
            <div>
              {tourData[expandedGroupIndex]?.tours?.map((tour, index) => {
                const categoryName = tourData?.find(
                  (group) => group.id === tour.categoryId
                )?.group;

                const Id = {
                  id: tour.id,
                  // title: tour?.tour,
                  title: `tour ${index + 1}`,
                  time: tour?.time,
                  category: categoryName,
                  categoryId: tour?.categoryId,
                  date: tour?.date,
                  endTime: tour?.endTime,
                  eventId: tour?.eventId,
                  eventItemId: tour?.eventItemId,
                  startTime: tour?.startTime,
                  tourId: tour?.tourId,
                  customerId: tour?.customerId,
                  booked: tour.booked,
                };

                return (
                  <div
                    key={index}
                    className="!leap-rounded-xl leap-p-[1px] leap-mb-6"
                    style={{
                      background:
                        tour.booked ||
                        selectedTours?.some(
                          (selected) =>
                            selected.id === tour.id &&
                            selected.categoryId == tour.categoryId
                        )
                          ? "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)"
                          : "#7300FF",
                    }}
                  >
                    <button
                      className={` leap-w-32  leap-bg-[#212053]
                         leap-text-white leap-rounded-xl leap-p-4 leap-flex 
                          leap-justify-between leap-items-center ${
                            tour.booked ||
                            selectedTours?.some(
                              (selected) =>
                                selected.id === tour.id &&
                                selected.categoryId == tour.categoryId
                            )
                              ? "leap-bg-[#515d7c] leap-text-black"
                              : "leap-bg-[#212053] leap-text-white"
                          }`}
                      onClick={() => handleTourClick(Id)}
                    >
                      <div className="leap-flex leap-flex-col leap-text-[11px]">
                        <span className="leap-text-[#73FAFD] leap-pb-2 leap-font-semibold  leap-uppercase">
                          {`tour ${index + 1}`}
                        </span>
                        <span className="">
                          <p>{formatTimeTo12Hour(tour?.startTime)}</p>
                          <p className="leap-mx-1">TO</p>
                          <p> {formatTimeTo12Hour(tour?.endTime)}</p>
                        </span>
                      </div>

                      {tour.booked ||
                      selectedTours?.some(
                        (selected) =>
                          selected.id === tour.id &&
                          selected.categoryId == tour.categoryId
                      ) ? (
                        <FaQuestionCircle
                          className="w-14 h-14 text-white" // Tailwind classes for size (w-4 = 1rem) and color (text-white)
                          style={{ color: "#ffff" }}
                          onClick={(e) => {
                            setGetTourId(tour?.tourId);
                            openCodeModal();
                            e.stopPropagation();
                          }}
                        />
                      ) : (
                        <FaQuestionCircle
                          className="w-14 h-14 text-white" // Tailwind classes for size (w-4 = 1rem) and color (text-white)
                          style={{ color: "#ffff" }}
                          onClick={(e) => {
                            setGetTourId(tour?.tourId);
                            openCodeModal();
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default ResponsiveTours;
